import { render, staticRenderFns } from "./ProductoFilters.vue?vue&type=template&id=4680b0a3&scoped=true&"
import script from "./ProductoFilters.vue?vue&type=script&lang=js&"
export * from "./ProductoFilters.vue?vue&type=script&lang=js&"
import style0 from "./ProductoFilters.vue?vue&type=style&index=0&id=4680b0a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680b0a3",
  null
  
)

export default component.exports